import React from 'react';
import SetPageTitle from 'components/Portals/SetPageTitle';
import SetPageNavAction from 'components/Portals/SetPageNavAction';
import { useTranslation } from 'services/localization/useTranslation';
import Payments from './Payments';

import { Routes, useTypedLocation } from 'routing';

const AccountPayments = () => {
	const { t } = useTranslation();
	const { state } = useTypedLocation();

	return (
		<>
			<SetPageTitle
				priority={2}
				title={t('shop.payments', t('account.payments.pageTitle', 'Payments'))}
			/>
			<SetPageNavAction
				priority={2}
				backAction={
					state?.from === Routes.HOME_VIEW
						? { to: Routes.HOME_VIEW, title: t('common:actions.home', 'Home') }
						: {
								to: Routes.ACCOUNT,
								title: t('account.pageTitle', 'Account'),
						  }
				}
				quickLinks={[]}
			/>
			<Payments />
		</>
	);
};

export default AccountPayments;
